module.exports = __webpack_public_path__ + "img/33ne.315534bf.svg";